import { LandingPageComponent } from './landing-page.component';
import { MapComponent } from './map/map.component';
import { AddressSearchComponent } from './address-search/address-search.component';
import { ServicesDescriptionComponent } from './services-description/services-description.component';
import { UploadInputComponent } from './upload-input/upload-input.component';
import { ComuneNoaAutocompleteComponent } from './comune-noa-autocomplete/comune-noa-autocomplete.component';
import { PoiAutocompleteComponent } from './poi-autocomplete/poi-autocomplete.component';
import { CoordinatesSearchComponent } from './coordinates-search/coordinates-search.component';
import { IdSearchComponent } from './id-search/id-search.component';
import { PopAutocompleteComponent } from './pop-autocomplete/pop-autocomplete.component';
import { MassiveImportViewComponent } from './massive-import-view/massive-import-view.component';
import { RoeAutocompleteComponent } from './roe-autocomplete/roe-autocomplete.component';
import { BasicAutocompleteComponent } from './basic-autocomplete/basic-autocomplete.component';
import { ComuneBuildingAutocompleteComponent } from './comune-building-autocomplete/comune-building-autocomplete.component';
import { PfsAutocompleteComponent } from './pfs-autocomplete/pfs-autocomplete.component';
import { ComuneRpiAutocompleteComponent } from './comune-rpi-autocomplete/comune-rpi-autocomplete.component';
import { ComunePoiAutocompleteComponent } from './comune-poi-autocomplete/comune-poi-autocomplete.component';
import { ComunePopAutocompleteComponent } from './comune-pop-autocomplete/comune-pop-autocomplete.component';

export const COMPONENTS = [
  LandingPageComponent,
  MapComponent,
  AddressSearchComponent,
  ServicesDescriptionComponent,
  UploadInputComponent,
  PoiAutocompleteComponent,
  PopAutocompleteComponent,
  ComuneNoaAutocompleteComponent,
  ComuneBuildingAutocompleteComponent,
  CoordinatesSearchComponent,
  IdSearchComponent,
  MassiveImportViewComponent,
  PfsAutocompleteComponent,
  RoeAutocompleteComponent,
  BasicAutocompleteComponent,
  ComuneRpiAutocompleteComponent,
  ComunePoiAutocompleteComponent,
  ComunePopAutocompleteComponent
];
